export default __webpack_public_path__ + "5f2309342610e0b112e0dcbccf0d6090.png";